import { formatCentsToCurrency } from "~/utils/currencyUtils.ts";
import { formatDateTimeToDate } from "~/utils/dateAndTimeUtils.ts";

const EMPTY = "—";

export const formatEInvoiceCents = (cents: number | null): string =>
	cents === null ? EMPTY : formatCentsToCurrency(cents);

export const formatEInvoiceDate = (value: string | null): string =>
	value === null ? EMPTY : formatDateTimeToDate(value, false, "yyyy")?.trim() ?? EMPTY;

export const formatEInvoicePercent = (rate: number | null): string =>
	rate === null ? EMPTY : `${rate.toLocaleString("de-DE")}%`;

export const joinDefined = (parts: Array<string | null>, separator: string): string => {
	const present = parts.filter((part): part is string => part !== null);

	return present.length > 0 ? present.join(separator) : EMPTY;
};
